import {frontPageContentManager} from '../../../api/frontPageContentManager';
import WelcomePageHeroBanner from '../../../api/welcomePageHeroBannerEntity';
import { actionTypes } from '../../../common/constants/actionTypes';

import { httpCallStartAction } from '../../../middlewares/http/actions';

export const fetchWelcomePageHeroBannerAction = () => (dispatch: any) => {
  dispatch(httpCallStartAction());

  frontPageContentManager.fetchWelcomePageHeroBannerAsync()
    .then((welcomePageBanner) => {
      dispatch(fetchWelcomePageHeroBannerCompleted(welcomePageBanner));
    });
};

const fetchWelcomePageHeroBannerCompleted = (welcomePageBanner: WelcomePageHeroBanner) => ({
  meta: {
    httpEnd: true,
  },
  payload: welcomePageBanner,
  type: actionTypes.FETCH_WELCOME_PAGE_HERO_BANNER_COMPLETED
});


// WEBPACK FOOTER //
// ./src/components/welcomePageHeroBanner/actions/fetchWelcomePageHeroBanner.ts